import { Link } from 'react-router-dom';
import { Boxes, Gift, ShieldCheck, Users } from 'lucide-react';

/** 인증 화면(로그인/회원가입) 좌측 브랜드 패널. 데스크톱에서만 표시. */
export function AuthBrandPanel() {
  return (
    <div className="relative hidden flex-col justify-between overflow-hidden bg-gradient-to-br from-primary to-emerald-700 p-12 text-white lg:flex">
      <div className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-white/10 blur-2xl" />
      <div className="pointer-events-none absolute -bottom-16 -left-10 h-64 w-64 rounded-full bg-black/10 blur-2xl" />
      <Link to="/" className="relative flex items-center gap-2 text-lg font-extrabold">
        <span className="flex h-8 w-8 items-center justify-center rounded-xl bg-white/20">
          <Boxes className="h-5 w-5" />
        </span>
        MOA.
      </Link>
      <div className="relative">
        <h2 className="text-3xl font-bold leading-tight">
          함께 모으면,
          <br />더 싸고 더 즐겁다
        </h2>
        <ul className="mt-6 space-y-3 text-white/85">
          <li className="flex items-center gap-2"><ShieldCheck className="h-5 w-5" /> 검증된 지역 판매자</li>
          <li className="flex items-center gap-2"><Users className="h-5 w-5" /> 함께할수록 저렴하게</li>
          <li className="flex items-center gap-2"><Gift className="h-5 w-5" /> 선물하기 지원</li>
        </ul>
      </div>
      <p className="relative text-sm text-white/70">지역 기반 대안적 소셜 이커머스</p>
    </div>
  );
}
